/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Dispatch, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { IErrorSNState, ISerialNumber } from '../../../models/service-request';
import TextInput from '../../inputs/text-input';
import moment from 'moment';
import SelectInput from '../../inputs/select-input';
import LookingUpSN from './looking-up-SN';
import AlertBox from './alert-box';
import { ENTER } from '../../common/constants';
import { designationHook } from '../../../hooks/pn-or-desination-hook';

interface IServiceRequestSNProps {
    index: number;
    lookingUpSN1: boolean;
    lookingUpSN2: boolean;
    setCurrentSN: Dispatch<React.SetStateAction<number>>;
    handleOnBlur: (pairDeviceSN?: string) => void;
    current: number;
    setCurrent: Dispatch<React.SetStateAction<number>>;
    data: ISerialNumber[];
    setData: Dispatch<React.SetStateAction<ISerialNumber[]>>;
    validating: boolean;
    setErrorSN: Dispatch<React.SetStateAction<IErrorSNState>>;
    hasConsent: boolean;
    SetShowFirstConsentModal: Dispatch<React.SetStateAction<boolean>>;
}
const ServiceRequestSN = ({
    index,
    lookingUpSN1,
    lookingUpSN2,
    setCurrentSN,
    handleOnBlur,
    current,
    setCurrent,
    data,
    setData,
    validating,
    setErrorSN,
    hasConsent,
    SetShowFirstConsentModal,
}: IServiceRequestSNProps) => {
    const intl = useIntl();
    const SN1Ref = useRef<HTMLInputElement | null>(null);
    const SN2Ref = useRef<HTMLInputElement | null>(null);
    useEffect(() => {
        if (
            !data[index].SN1 ||
            data[index].error1 ||
            (data[index].SN1 && !data[index].device1) ||
            (data[index].SN2 && data[index].error2) ||
            (data[index].SN2 && !data[index].device2) ||
            (data[index].warning1 && !data[index].RN1) ||
            (data[index].warning2 && !data[index].RN2)
        ) {
            setErrorSN((errorSN) => ({ ...errorSN, [index]: true }));
        } else {
            setErrorSN((errorSN) => ({ ...errorSN, [index]: false }));
        }
    }, [data]);

    return (
        <div className="SN-container-absolute">
            <div className="SN-number-box-container">
                <div
                    className={
                        current === index
                            ? 'SN-number-box'
                            : 'SN-number-box SN-number-box-inactive'
                    }
                    id={`serialNumber${index + 1}Box`}
                    style={{
                        position: 'relative',
                        left: `${index * 65}px`,
                    }}
                    onClick={() => setCurrent(index)}
                >
                    {index + 1}
                </div>
            </div>
            <div
                className="well SN-container"
                style={
                    current === index
                        ? { display: 'grid' }
                        : { display: 'none' }
                }
            >
                <div className="form-horizontal">
                    <div id={`page${index + 1}SerialNumber1Container`}>
                        <TextInput
                            innerRef={SN1Ref}
                            name="serialNumber"
                            label="SERIAL NUMBER 1 UPPER"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            value={data[index].SN1}
                            maxLength={15}
                            onChange={(e) => {
                                e.persist();
                                setCurrentSN(1);
                                setData(
                                    data.map((dataObj, i) =>
                                        index === i
                                            ? {
                                                  ...dataObj,
                                                  SN1: e.target.value,
                                                  SN1changed: true,
                                              }
                                            : dataObj
                                    )
                                );
                            }}
                            onBlur={() => {
                                if (!hasConsent) {
                                    SetShowFirstConsentModal(true);
                                } else {
                                    setTimeout(() => handleOnBlur(), 100);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === ENTER && SN1Ref.current) {
                                    SN1Ref.current.blur();
                                }
                            }}
                            required={true}
                            isOldStyleRequired={true}
                            error={
                                (validating && !data[index].SN1) ||
                                data[index].error1
                                    ? 'error'
                                    : undefined
                            }
                            warning={data[index].warning1 ? true : false}
                        />
                        {lookingUpSN1 &&
                            data[index].SN1 &&
                            data[index].SN1changed && <LookingUpSN />}
                        {!lookingUpSN1 && data[index].error1 && (
                            <AlertBox
                                alert={data[index].error1}
                                typeOfAlert="error"
                            />
                        )}
                        {!lookingUpSN1 && data[index].warning1 && (
                            <AlertBox
                                alert={data[index].warning1}
                                typeOfAlert="warning"
                            />
                        )}
                        {!lookingUpSN1 && data[index].warning1 && (
                            <TextInput
                                name="referenceNumber"
                                label="Reference Number"
                                labelClassName="control-label col-sm-4 col-md-3"
                                fieldClassName="col-sm-8 col-md-6"
                                value={data[index].RN1}
                                maxLength={20}
                                onChange={(e) => {
                                    e.persist();
                                    if (
                                        !e.target.value.match(/^[0-9]+$/) &&
                                        e.target.value
                                    )
                                        return;
                                    setData(
                                        data.map((dataObj, i) =>
                                            index === i
                                                ? {
                                                      ...dataObj,
                                                      RN1: e.target.value,
                                                  }
                                                : dataObj
                                        )
                                    );
                                }}
                                required={true}
                                isOldStyleRequired={true}
                                error={
                                    validating && !data[index].RN1
                                        ? 'error'
                                        : undefined
                                }
                            />
                        )}
                        {!lookingUpSN1 && data[index].device1 && (
                            <>
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Item_Description',
                                            defaultMessage: 'Item Description',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        id={`page${
                                            index + 1
                                        }SN1ItemDescription`}
                                        style={{ color: '#58595b' }}
                                    >
                                        {data[index].device1!.hearingAidType}
                                    </p>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Patient_Name',
                                            defaultMessage: 'Patient Name',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        id={`page${index + 1}SN1PatientName`}
                                        style={{ color: '#58595b' }}
                                    >
                                        {data[index].patient1First +
                                            ' ' +
                                            data[index].patient1Last}
                                    </p>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Invoice_Date',
                                            defaultMessage: 'Invoice Date',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        id={`page${index + 1}SN1InvoiceDate`}
                                        style={{ color: '#58595b' }}
                                    >
                                        {moment
                                            .utc(
                                                data[index].device1!
                                                    .purchaseDate
                                            )
                                            .format('M/D/YYYY')}
                                    </p>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Current_Color',
                                            defaultMessage: 'Current Color',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        id={`page${index + 1}SN1CurrentColor`}
                                        style={{ color: '#58595b' }}
                                    >
                                        {data[index].device1!.color.name}
                                    </p>
                                </div>
                                {data[index].device1 &&
                                    data[index].pairDevice1 &&
                                    designationHook(
                                        data[index].device1!.partNumber
                                    ) ===
                                        designationHook(
                                            data[index].pairDevice1!.partNumber
                                        ) &&
                                    !data[index].SN2 &&
                                    !data[index].SN2changed && (
                                        <div className="form-group">
                                            <label className="control-label col-sm-4 col-md-3"></label>
                                            <a
                                                className="form-control-static col-sm-8 col-md-6"
                                                id={`page${
                                                    index + 1
                                                }PairDeviceLink`}
                                                onMouseEnter={() => {
                                                    setCurrentSN(2);
                                                    SN2Ref.current!.blur();
                                                }}
                                                onClick={() => {
                                                    setData(
                                                        data.map((dataObj, i) =>
                                                            index === i
                                                                ? {
                                                                      ...dataObj,
                                                                      SN2: data[
                                                                          index
                                                                      ]
                                                                          .pairDevice1!
                                                                          .serialNumber,
                                                                      SN2changed:
                                                                          true,
                                                                  }
                                                                : dataObj
                                                        )
                                                    );

                                                    handleOnBlur(
                                                        data[index].pairDevice1!
                                                            .serialNumber
                                                    );
                                                }}
                                            >
                                                {intl.formatMessage({
                                                    id: 'Click_here_to_include_other_side ',
                                                    defaultMessage:
                                                        'Click here to include other side',
                                                })}
                                                (
                                                {
                                                    data[index].pairDevice1!
                                                        .serialNumber
                                                }
                                                )
                                            </a>
                                        </div>
                                    )}
                            </>
                        )}
                    </div>
                    <div id={`page${index + 1}SerialNumber2Container`}>
                        <TextInput
                            innerRef={SN2Ref}
                            name="serialNumber"
                            label="SERIAL NUMBER 2 UPPER"
                            labelClassName="control-label col-sm-4 col-md-3"
                            fieldClassName="col-sm-8 col-md-6"
                            value={data[index].SN2}
                            maxLength={15}
                            onChange={(e) => {
                                e.persist();
                                setCurrentSN(2);
                                setData(
                                    data.map((dataObj, i) =>
                                        index === i
                                            ? {
                                                  ...dataObj,
                                                  SN2: e.target.value,
                                                  SN2changed: true,
                                              }
                                            : dataObj
                                    )
                                );
                            }}
                            onBlur={() => {
                                if (!hasConsent) {
                                    SetShowFirstConsentModal(true);
                                } else {
                                    setTimeout(() => handleOnBlur(), 100);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === ENTER && SN2Ref.current) {
                                    SN2Ref.current.blur();
                                }
                            }}
                            error={data[index].error2 ? 'error' : undefined}
                            warning={data[index].warning2 ? true : false}
                        />
                        {lookingUpSN2 &&
                            data[index].SN2 &&
                            data[index].SN2changed && <LookingUpSN />}
                        {!lookingUpSN2 && data[index].error2 && (
                            <AlertBox
                                alert={data[index].error2}
                                typeOfAlert="error"
                            />
                        )}
                        {!lookingUpSN2 && data[index].warning2 && (
                            <AlertBox
                                alert={data[index].warning2}
                                typeOfAlert="warning"
                            />
                        )}
                        {!lookingUpSN2 && data[index].warning2 && (
                            <TextInput
                                name="referenceNumber"
                                label="Reference Number"
                                labelClassName="control-label col-sm-4 col-md-3"
                                fieldClassName="col-sm-8 col-md-6"
                                value={data[index].RN2}
                                maxLength={20}
                                onChange={(e) => {
                                    e.persist();
                                    if (
                                        !e.target.value.match(/^[0-9]+$/) &&
                                        e.target.value
                                    )
                                        return;
                                    setData(
                                        data.map((dataObj, i) =>
                                            index === i
                                                ? {
                                                      ...dataObj,
                                                      RN2: e.target.value,
                                                  }
                                                : dataObj
                                        )
                                    );
                                }}
                                required={true}
                                isOldStyleRequired={true}
                                error={
                                    validating && !data[index].RN2
                                        ? 'error'
                                        : undefined
                                }
                            />
                        )}
                        {!lookingUpSN2 && data[index].device2 && (
                            <>
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Item_Description',
                                            defaultMessage: 'Item Description',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        id={`page${
                                            index + 1
                                        }SN2ItemDescription`}
                                        style={{ color: '#58595b' }}
                                    >
                                        {data[index].device2!.hearingAidType}
                                    </p>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Patient_Name',
                                            defaultMessage: 'Patient Name',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        id={`page${index + 1}SN2PatientName`}
                                        style={{ color: '#58595b' }}
                                    >
                                        {data[index].patient2First +
                                            ' ' +
                                            data[index].patient2Last}
                                    </p>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Invoice_Date',
                                            defaultMessage: 'Invoice Date',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        id={`page${index + 1}SN2InvoiceDate`}
                                        style={{ color: '#58595b' }}
                                    >
                                        {moment
                                            .utc(
                                                data[index].device2!
                                                    .purchaseDate
                                            )
                                            .format('M/D/YYYY')}
                                    </p>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4 col-md-3">
                                        {intl.formatMessage({
                                            id: 'Current_Color',
                                            defaultMessage: 'Current Color',
                                        })}
                                        :
                                    </label>
                                    <p
                                        className="form-control-static col-sm-8 col-md-6"
                                        id={`page${index + 1}SN2CurrentColor`}
                                        style={{ color: '#58595b' }}
                                    >
                                        {data[index].device2!.color.name}
                                    </p>
                                </div>
                            </>
                        )}
                        {!lookingUpSN1 && data[index].device1 && (
                            <SelectInput
                                name="newColorChoice"
                                label="New Color"
                                labelClassName="control-label col-sm-4 col-md-3"
                                fieldClassName="col-sm-8 col-md-6"
                                options={data[index].colors}
                                hasDefaultOption={false}
                                onChange={(e) => {
                                    e.persist();
                                    setData(
                                        data.map((dataObj, i) =>
                                            index === i
                                                ? {
                                                      ...dataObj,
                                                      newColor: e.target.value,
                                                  }
                                                : dataObj
                                        )
                                    );
                                }}
                                required={false}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceRequestSN;
